<!--suppress JSUnresolvedVariable, ES6CheckImport -->
<template>
  <div class="recruitment-center">
    <div
      class="top jumbotron jumbotron-fluid mb-2"
      :style="{ backgroundImage: 'url(' + backgroundUrl + ')' }"
    >
      <div class="container text-info">
        <h1 class="animated fadeInDown">招贤纳士</h1>
        <p class="animated fadeInDown">—— {{ sectionSubTitle }} ——</p>
      </div>
    </div>
    <div class="container content my-5">
      <!-- 当前位置 -->
      <div class="text-right position d-none d-md-block text-muted">
        当前位置：
        <router-link to="/toHome" class="text-muted">首页</router-link>
        /
        <a href="#" class="text-muted">招贤纳士</a>
      </div>
      <div class="row">
        <div
          class="my-3 mb-md-3 col-12 col-sm-6 col-lg-3 animated zoomIn"
          v-for="item in jobList"
          :key="item.jobId"
        >
          <div class="card border-0 shadow">
            <div class="card-header font-weight-bold text-white bg-info">
              招聘职位：{{ item.jobName }}
            </div>
            <div class="card-body">
              <p class="card-text text-muted" v-html="item.jobContent"></p>
              <a
                class="btn btn-outline-info btn-sm mt-2 text-info"
                @click="updateJobViews(item.jobId)"
              >
                查看详情
              </a>
            </div>
            <div class="card-footer text-white bg-info">
              发布日期：{{ item.publishTime }}
            </div>
          </div>
        </div>
      </div>
      <div class="text-center m-4 wow fadeInDown">
        <a
          type="danger"
          @click="findMore()"
          class="btn text-info text-decoration-none font-weight-bold"
          v-if="this.total !== this.jobList.length"
        >
          <img :src="moreImgUrl" alt="logo" width="40" class="rounded-circle" />
          加载更多
        </a>
        <el-divider v-if="this.total === this.jobList.length">
          <small class="text-muted">我可是有底线的</small>
        </el-divider>
      </div>
    </div>
  </div>
</template>

<script>
import { WOW } from "wowjs";

export default {
  name: "RecruitmentCenter",
  data() {
    return {
      sectionSubTitle: "",
      moreImgUrl: "",
      logSys: 1,
      backgroundUrl: "",
      currentPage: 1,
      pageSize: 8,
      total: 0,
      jobList: []
    };
  },
  mounted() {
    let options = { live: false };
    new WOW(options).init();
    this.isSystem();
    this.getNavById();
    this.getAllJobList();
  },
  methods: {
    isSystem() {
      if (navigator.userAgent.match("Android")) {
        this.logSys = 2;
      } else if (navigator.userAgent.match("iPhone")) {
        this.logSys = 3;
      } else if (navigator.userAgent.match("iPad")) {
        this.logSys = 3;
      } else {
        this.logSys = 1;
      }
    },
    getNavById() {
      this.axios
        .get("/navigation/getNavById/" + 5)
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            this.backgroundUrl = resp.data.data.bannerImg;
            this.sectionSubTitle = resp.data.data.subTitle;
            this.moreImgUrl = resp.data.data.moreImgUrl;
          }
        })
        .catch();
    },
    getAllJobList() {
      this.axios
        .get("/job/getAllJobList", {
          params: {
            currentPage: this.currentPage,
            pageSize: this.pageSize
          }
        })
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            this.jobList = this.jobList.concat(resp.data.data.records);
            this.total = resp.data.data.total;
            this.currentPage += 1;
          }
        })
        .catch();
    },
    findMore() {
      this.getAllJobList();
    },
    updateJobViews(jobId) {
      this.axios
        .put("/job/updateJobViews/" + jobId, {
          logSys: this.logSys
        })
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            this.$router
              .push({ name: "CareersDetail", params: { jobId: jobId } })
              .catch();
          }
        })
        .catch();
    }
  }
};
</script>

<style scoped lang="scss">
.recruitment-center {
  margin-top: 67px;

  .top {
    background: no-repeat center;
    width: 100%;
    background-size: cover;
  }

  .content {
    .row {
      div {
        .card {
          .card-body {
            h6 {
              font-size: 14px;
            }

            p {
              height: 83px;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 4;
              overflow: hidden;
            }
          }
        }
      }
    }

    .el-divider__text {
      background-color: #fff;
    }
  }
}
</style>
